import styled from 'styled-components';

export const BannerImage = styled.img`
  display: block;
  width: 100%;
  height: 150px;
  object-fit: cover;
  object-position: ${props => props.$bannerPosition};
  border-radius: 0 0 16px 16px;
`;
